import { render, staticRenderFns } from "./LearnMorePopover.vue?vue&type=template&id=3635c4ea&scoped=true"
import script from "./LearnMorePopover.vue?vue&type=script&lang=ts"
export * from "./LearnMorePopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635c4ea",
  null
  
)

export default component.exports